export default "__VITE_ASSET__CfmOicO$__"